import React from 'react';
import {FormErrorMessage} from '../../../form-features/FormErrorMessage';
import {InputStructure} from './InputStructure';

export const RawInput = ({disabled, label, prefix, suffix, type, validationError, styleFile, ...props}) => (
    <InputStructure
        styleFile={styleFile}
        label={label}
        prefix={prefix}
        suffix={suffix}
        disabled={disabled}
        errorMessage={<FormErrorMessage>{validationError && <>{validationError}</>}</FormErrorMessage>}>
        <input disabled={disabled} type={type} {...props} />
    </InputStructure>
);
